import script from "./base-accordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-accordion.vue?vue&type=script&setup=true&lang=ts"

import "./base-accordion.vue?vue&type=style&index=0&id=683fbf07&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-683fbf07"]])

export default __exports__